// The sign-off every email we draft ends with (D180).
// MIRRORED FILE: src/utils/emailSignOff.js is its twin (mirroredUtilParity.test.js).

export const EMAIL_SIGN_OFF = 'Best regards,\nUnited Ship Chandlers';
